<template>
  <form @submit.prevent="login">
    <main class="flex-item">
      <div class="columns">
        <div
          class="
            column
            is-half-desktop
            is-offset-one-quarter-desktop
            is-half-widescreen
            is-offset-one-quarter-widescreen
            is-half-fullhd
            is-offset-one-quarter-fullhd
            is-12-tablet
            is-12-mobile
          "
        >
          <div class="card">
            <header class="card-header page-title">
              <p class="card-header-title is-size-4">
                <span class="material-icons is-size-4">login</span>
                ログイン
              </p>
            </header>
            <div class="card-content">
              <div class="field">
                <label class="label">
                  ログインID
                  <span class="tag is-danger is-light is-rounded ml-2">必須</span>
                </label>
                <div class="control has-icons-left has-icons-right">
                  <input class="input" type="text" v-model="loginForm.userId" />
                  <span class="icon is-small is-left">
                    <span class="material-icons">person</span>
                  </span>
                </div>
                <p class="help is-danger" v-for="e of f$.userId.$errors" :key="e.$uid">
                  {{ e.$message }}
                </p>
              </div>
              <div class="field">
                <label class="label">
                  パスワード
                  <span class="tag is-danger is-light is-rounded ml-2">必須</span>
                </label>
                <div class="control has-icons-left has-icons-right">
                  <input class="input" type="password" v-model="loginForm.password" />
                  <span class="icon is-small is-left">
                    <span class="material-icons">lock</span>
                  </span>
                </div>
                <p class="help is-danger" v-for="e of f$.password.$errors" :key="e.$uid">
                  {{ e.$message }}
                </p>
              </div>

              <div class="field">
                <p class="help is-danger" v-for="(e, i) of g$" :key="i">
                  {{ e }}
                </p>
              </div>
            </div>

            <footer class="card-footer">
              <div class="card-footer-item">
                <button class="card-footer-item button is-primary is-normal" @click.prevent="login">ログイン</button>
              </div>
            </footer>
          </div>

          <div class="card mt-5">
            <header class="card-header card-title">
              <p class="card-header-title is-size-4"><span class="material-icons accent-color">person_outline</span>お問い合わせ</p>
            </header>
            <div class="card-content contractor-info">
              <label class="label mb-0">【WEBからのお問い合わせ】</label>
              <p class="mb-3"><a href="http://www.sanko-syougakutanki.co.jp/ask2.html">http://www.sanko-syougakutanki.co.jp/ask2.html</a></p>
              <label class="label mb-0">【電話でのお問い合わせ】</label>
              <p class="mb-3">0120-00-8188（受付時間：10:00～18:00）</p>
            </div>
          </div>
        </div>
      </div>
    </main>
  </form>
</template>
<script lang="ts">
import { defineComponent, reactive, ref, UnwrapRef } from "vue";
import { LoginRequest, loginValidateRule, postLogin } from "@/api/login";
import useVuelidate from "@vuelidate/core";
import axios from "axios";
import { ErrorResponse } from "common/src/utils/request";
import { setErrorMessage } from "common/src/utils/validate";
import router from "@/router";
import constants from "common/src/constants";
import { MutationTypes, useStore } from "@/store";
import { getMe } from "common/src/api/me";

/**
 * 画面ID: SCR200
 * 画面内容: ログイン画面
 */
export default defineComponent({
  setup() {
    // フォーム変数作成
    const loginForm: UnwrapRef<LoginRequest> = reactive({
      userId: "",
      password: "",
      authType: "",
    });

    // 全体エラーメッセージ
    const g$: string[] = reactive([]);

    // フィールドエラーを外部からセットする変数
    const $externalResults = ref({});
    // フィールドエラー設定初期化
    const f$ = useVuelidate(loginValidateRule, loginForm, {
      $autoDirty: true,
      $externalResults,
    });

    const store = useStore();

    const login = async () => {
      // 外部フィールドエラーリセット
      f$.value.$clearExternalResults();
      // 全体エラーリセット
      g$.splice(0, g$.length);
      f$.value.$touch();
      if (f$.value.$invalid) return;

      try {
        // API0010(ログイン)呼び出し
        const res = await postLogin(loginForm);

        // トークンをセッションストレージへ格納
        // トークンは共通処理で使用する関係で直接セッションストレージを使用
        window.sessionStorage.setItem(constants.ACCESS_TOKEN_KEY_MYPAGE, res.data.accessToken);
        window.sessionStorage.setItem(constants.REFRESH_TOKEN_KEY_MYPAGE, res.data.refreshToken);

        // API0040(認証者情報取得)呼び出し
        const me = await getMe();

        // 認証者情報をストアへ格納
        store.commit(MutationTypes.SET_ME, me.data);
        router.push({ name: "Top" });
      } catch (err) {
        if (axios.isAxiosError(err) && (err.response?.status === 400 || err.response?.status === 403)) {
          setErrorMessage(g$, $externalResults, err.response?.data as ErrorResponse);
        }

        // 利用者情報取得APIでエラーが出ることを考慮しトークンをセッションストレージから削除
        window.sessionStorage.removeItem(constants.ACCESS_TOKEN_KEY_MYPAGE);
        window.sessionStorage.removeItem(constants.REFRESH_TOKEN_KEY_MYPAGE);
      }
    };

    return {
      loginForm,
      login,
      f$,
      g$,
    };
  },
});
</script>
